import { useEffect, useMemo, useState } from 'react'
import { PlusIcon } from '@phosphor-icons/react'
import { ThemeItem } from '../ThemeItem/ThemeItem'
import _ from 'lodash'
import { DEFAULT_CHART_PREFERENCES } from '../styleConsts'
import { ScoopTheme } from '../../../../../Insights/Style'
import { ScoopButton, ScoopSearchBar, ScoopRow, ScoopColumn } from '../../../../../ui'
import styles from '../StyleTab.module.scss'
import { useModal, MODALS } from '../../../../../modals'

export const ThemesConfig = ({
    server,
    config,
    setConfig,
    setSelectedProp,
    workspaceMetadata,
    openCreateTheme,
    previousTheme,
    previousStyleOverrides,
    getWorkspaceMetadata,
}) => {
    const [search, setSearch] = useState('')
    const [themeId, setThemeId] = useState('')
    const themes = useMemo(() => workspaceMetadata?.themes || [], [workspaceMetadata])

    // Modal Manager hooks
    const deleteModal = useModal(MODALS.COMMON.DELETE)

    useEffect(() => {
        if (!config.themeID) {
            handleChangeTheme({
                themeID: 'defaultTheme',
                themeName: 'Default theme',
                colorScheme: {
                    backgroundColor: '#FFFFFF',
                    colors: ScoopTheme.color,
                    darkTheme: false,
                },
            })
        }
    }, [])

    const handleChangeTheme = (theme) => {
        const newConfig = _.cloneDeep(config)
        newConfig.themeID = theme.themeID
        if (theme.themeID === previousTheme) {
            newConfig.styleOverrides = previousStyleOverrides
        } else {
            newConfig.styleOverrides = DEFAULT_CHART_PREFERENCES
        }
        setConfig({ ...newConfig })
    }

    const handleDeleteTheme = (themeID) => {
        setThemeId(themeID)
        deleteModal.show({
            title: 'theme',
            description: 'Are you sure you want to delete this theme?',
            onConfirm: () => {
                server.postData(
                    {
                        action: 'deleteObject',
                        class: 'scoop.presentation.Theme',
                        key: themeID,
                    },
                    () => {
                        getWorkspaceMetadata()
                        setThemeId('')
                    }
                )
            },
        })
    }

    const compareThemes = (a, b) => {
        if (a.themeName < b.themeName) return -1
        if (a.themeName > b.themeName) return 1
        return 0
    }

    return (
        <>
            <ScoopRow className={styles.themesSearchbar}>
                <ScoopSearchBar
                    value={search}
                    placeholder="Search themes"
                    onChange={(e) => setSearch(e.target.value)}
                    width="100%"
                    height="38px"
                    debounceMs={0}
                />
                <ScoopButton variant="text" size="xxs" onClick={openCreateTheme}>
                    <PlusIcon size={18} />
                </ScoopButton>
            </ScoopRow>
            <ScoopColumn className={styles.themesList}>
                <ThemeItem
                    key={'defaultTheme'}
                    theme={{
                        themeID: 'defaultTheme',
                        themeName: 'Default theme',
                        colorScheme: {
                            backgroundColor: '#FFFFFF',
                            colors: ScoopTheme.color.map((c) => ({ val: c })),
                        },
                    }}
                    selectedTheme={config.themeID}
                    onClick={() =>
                        handleChangeTheme({
                            themeID: 'defaultTheme',
                            themeName: 'Default theme',
                            colorScheme: {
                                backgroundColor: '#FFFFFF',
                                colors: ScoopTheme.color,
                                darkTheme: false,
                            },
                        })
                    }
                    setSelectedProp={setSelectedProp}
                />
                {themes
                    .filter(
                        (t) =>
                            t.themeName && t.themeName.toLowerCase().includes(search.toLowerCase())
                    )
                    .sort(compareThemes)
                    .map((theme) => (
                        <ThemeItem
                            key={theme.themeID}
                            theme={theme}
                            selectedTheme={config.themeID}
                            onClick={() => handleChangeTheme(theme)}
                            setSelectedProp={setSelectedProp}
                            handleDelete={handleDeleteTheme}
                        />
                    ))}
            </ScoopColumn>
        </>
    )
}
